module.exports = __webpack_public_path__ + "img/tou.6cf6c0b3.png";